<template>
  <div class="prescription_input prescription">
    <div class="bz_yk ucard">
      <div class="ucard_hander">
        <span class="ucard_title">拟定处方</span>
        <div class="ucard_title_right">
          <template v-if="pageType">
            <Button size="small" v-if="!isRecall" class="recallBtn" @click="zaohui(1)">召回病历</Button>
            <template v-if="!hideAi">
              <Button size="small" class="recallBtn" v-uEdition="'YZ-03'" @click="etiologicalAnalysisShow = true">
                <Icon type="ios-arrow-back" />病因分析
              </Button>
            </template>
            <span v-if="!spinShow">
              <Dropdown @on-click="clikMenu">
                <Button size="small" icon="md-print">打印</Button>
                <DropdownMenu slot="list">
                  <DropdownItem name="1">病历</DropdownItem>
                  <DropdownItem name="2">饮食宜忌</DropdownItem>
                  <DropdownItem name="3">医嘱</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </span>
          </template>

          <Button size="small" :loading="indexSpin.show" @click="submitPrescription" type="primary">提交处方</Button>
        </div>
      </div>
      <drug-input v-if="showDrugInput" :drugtaboo="defaultDrugtaboo" @change="saveData" @tabooChange="tabooChange"
        @teaBagFlgChange="teaBagFlgChange" :prescriptionInfo="prescription" :insertDrugFun="insertDrugFun"
        :pageType="pageType" ref="drugInput" :info="info" :activeConsult="selectConsultData.activeConsult" />

      <div class="u_medical_advice" v-else>
        <div class="cf_content">
          <div class="load_tip auto-prescr-error" v-if="autoPrescriptionError">
            <div class="title">自动开方出错：</div>
            <div class="content">{{ autoPrescriptionError }}</div>
            <div class="content">
              <Button type="primary" size="small" @click="zaohui">召回重新提交试试</Button>
            </div>
          </div>
          <div class="load_tip" v-else>
            <img src="@/assets/images/wz.png" alt />
            <uSpin />
            <!-- <div class="tip">等待socket消息中</div> -->
          </div>
        </div>
      </div>
    </div>

    <etiologicalAnalysis :recall="zaohui" :info="info" v-uEdition="'YZ-03'" v-show="etiologicalAnalysisVShow" :show="etiologicalAnalysisVShow"
      v-if="pageType && etiologicalAnalysisShow && info && info.prescriptionNo" @close="etiologicalAnalysisClose" />

    <etiologicalAnalysisWorkFlow :info="info" v-if="pageType && etiologicalAnalysisWorkFlowShow && isHasAuth('YZ-35')"
      @close="etiologicalAnalysisWorkFlowShow = false" />

    <!-- 病历打印 -->
    <medicalRecordPrint v-if="info.prescriptionNo" v-model="printWin" :drugList="drugListFormat" :info="info"
      :taboo="drugtaboo" :quantity="prescription.Quantity" />

    <!-- 打印医嘱禁忌 -->
    <doctorAdvice ref="doctorAdvice" :info="info" :taboo="drugtaboo" />

    <Modal v-model="showTip" width="900" title="提示" footer-hide :closable="false" :mask-closable="false">
      <div class="symptom_select_input_tip">
        <div class="title">
          <Icon type="md-alert" />
          请到互联网医院小程序进行CA处方签名
        </div>
        <div>
          <div>
            <span class="name">{{ info.patientName }}</span>
            <span class="phone">{{ info.cellphoneNo }}</span>
          </div>
          <div class="time">时间：{{ time }}</div>
        </div>
        <div class="qm">如何CA签名?</div>
        <div class="img-group">
          <div class="img-box">
            <img src="@/assets/images/web/1.png" />
          </div>
          <div class="img-box">
            <img src="@/assets/images/web/2.png" />
          </div>
          <div class="img-box">
            <img src="@/assets/images/web/3.png" />
          </div>
        </div>
        <div class="footer">
          <Button size="large" type="primary" @click="closeTip">我已完成签名</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import print from "./print";
import etiologicalAnalysis from "@/com/etiologicalAnalysis";
import { mapGetters } from "vuex";
import DrugTable from "./drugInput/drugTable.vue";
import DrugInput from "./drugInput/drugInput.vue";
import dayjs from "dayjs";
import { hasAuth } from "@/utils/uEdition.js";
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    quoteDurgList: {
      type: Array,
      default: () => [],
    },
    //页面类型  true:前端医生 false:后端医生
    pageType: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    etiologicalAnalysis,
    print,
    DrugTable,
    DrugInput,
  },
  data() {
    return {
      resDrugList: [],
      selectConsultData: {
        // 查询上次是否主动咨询 1 是 0 否
        activeConsult: 0,
        consultDate: "",
      },
      isStart: false,
      showTip: false,
      showDrugInput: false,
      printWin: false,
      prescribeByBillNoList: [], //合作医生获取徐氏医生开方信息
      resPrescribe: "", // 用于记录修改日志
      sendMessageSecond: 1, //接口请求次数
      etiologicalAnalysisShow: true,
      etiologicalAnalysisVShow: true,

      etiologicalAnalysisWorkFlowShow: false,

      photoReminder: false, //病历拍照提醒
      confirm: false,
      drugtaboo: "",
      defaultDrugtaboo: "",
      state: 0, // 状态(0开方未结束 1开方已结束)

      // 开方信息
      prescription: {
        Quantity: 1,
        drugList: [],
        returnVisitDate: "", //应复诊时间
        fzRemindDate: "", //复诊提醒时间
        planInfo: {}, // 方案信息
        teaBagFlg: false, //是否是茶包处方 1 是 0 否
        activeConsultFlg: 0, //是否继续主动咨询 1 是 0 否
        unreferencedReason: "", //未引用咨询处方的原因
        merId: "", // 未引用原因传入：merId
        meId: "", // 未引用原因传入：meId
      },

      autoPrescriptionError: "", //自动开方错误
    };
  },
  computed: {
    ...mapGetters([
      "addMedicalRecordSymptom",
      "hideAi",
      "indexSpin",
      "prescribeRegisterList", // 就诊中及未就诊挂号(处方单)
      "userSystemConfig",
      "keyInfo",
      "drug",
      "spinShow", //处方加载动画开关
      "isRecall",
      "savePrescription",
      "bnf", //百年方Drug_Code
      "isAnalysisList",
    ]),
    recordSymptom() {
      return this.addMedicalRecordSymptom[this.info.registerCode] || [];
    },
    drugListFormat() {
      return this.prescription.drugList.map((i) => {
        return {
          amount: i.Amount,
          discountRate: i.discountRate,
          drugCode: i.Drug_Code,
          drugDecoctPattern: i.drugDecoctPattern,
          drugName: i.Drug_Name,
          drugTakePattern: i.drugTakePattern,
          drugType: i.Drug_Type,
          quantity: i.Quantity,
          salesPrice: 0,
          specifications: i.specifications,
          unit: i.unit || i.UnitName,
        };
      });
    },
    time() {
      return dayjs().format("YYYY-MM-DD HH:mm:ss");
    },
  },
  watch: {
    quoteDurgList(value) {
      if (value.length) {
        this.loadCf(value);
      }
    },
    info(value) {
      this.init();
    },
  },
  methods: {
    isHasAuth(str) {
      return hasAuth(str);
    },
    teaBagFlgChange(val) {
      this.prescription.teaBagFlg = val;
    },
    etiologicalAnalysisClose() {
      this.etiologicalAnalysisShow = false;
    },
    clikMenu(name) {
      switch (name) {
        case "1":
          this.printWin = true;
          break;
        case "2":
          this.$refs.drugInput.tabooPrint();
          break;
        case "3":
          this.$refs.doctorAdvice.print();
          break;
      }
    },
    tabooChange(taboo) {
      this.drugtaboo = taboo;
    },
    // 前端医生获取处方
    getPrescribeByBillNoList() {
      let billNo = this.info.prescriptionNo; // 处方ID
      this.state = billNo ? 1 : 0;

      if (!billNo) {
        return;
      }
      let registerCode = this.info.registerCode;
      this.$store.commit("addResultDirectReturn", registerCode); //添加10秒倒计时
      this.api2("getPrescribeByBillNoList", { billNo })
        .then((res) => {
          this.$store.commit("sendLog", {
            apiName: "getPrescribeByBillNoList",
            remarks: "获取徐氏专家处方",
            inParams: { prescriptionNo: this.info.prescriptionNo },
            outParams: res,
          });
          this.$store.commit("delResultDirectReturn", registerCode); //删除超时后的回退操作
          if (!res.result[0].drugsList.length) {
            //如果没有药品列表
            if (this.sendMessageSecond > 3) {
              ViewUI.Modal.confirm({
                title: "提示",
                content: "获取处方失败,是否再获取一次?",
                onOk: () => {
                  this.$store.commit("sendMessage_symptom", {
                    registerCode,
                    success: false,
                  });
                },
                onCancel: () => { },
              });
            } else {
              this.$store.commit("sendMessage_symptom", {
                registerCode,
                success: false,
              });
            }
            this.sendMessageSecond++;
          } else {
            // 测试 暂时关了看效果
            this.$store.commit("setSpinShow", false);
            this.sendMessageSecond = 1;
            this.prescribeByBillNoList = res.result[0];
            this.resPrescribe = JSON.stringify(
              this.prescribeByBillNoList.drugsList
            );
            this.drugtaboo = this.prescribeByBillNoList.drugtaboo || "";
            this.defaultDrugtaboo = this.drugtaboo;
            this.setPrescribe();
            this.prescription.teaBagFlg = this.prescribeByBillNoList.teaBagFlg == 1;
            this.prescription.fzRemindDate = this.prescribeByBillNoList.fzRemindDate || "";

            this.$nextTick(() => {
              this.$refs.drugInput?.setTeaBagFlg();
            })
          }
        })
        .finally(() => { });
    },

    // 获取库存
    setPrescribe() {
      this.setPrescribe2();
      this.showDrugInput = true;
    },
    async setPrescribe2() {
      this.isStart = true;
      setTimeout(() => {
        this.isStart = false;
      }, 300);

      this.prescription.drugList = [];
      this.resDrugList = [];
      let obj = this.prescribeByBillNoList;
      let item = this.savePrescription[this.info.registerCode];

      if (item && item.drugList.length) {
        this.prescription.unreferencedReason = item.unreferencedReason;
        this.prescription.planInfo = item.planInfo;
        this.prescription.Quantity = item.Quantity;
        this.prescription.drugList = item.drugList.map((i) => {
          let drugItem = this.drug.find((j) => j.Drug_Code == i.Drug_Code);
          if (drugItem) i.StockQty = drugItem.StockQty;
          return i;
        });
        // this.$bus.emit("setPrescriptionSelectActive", this.prescription.drugList.map((i) => i.drugCode));
      }
      if (!(item && item.drugList.length) || this.hideAi) {
        this.prescription.Quantity = obj.quantity;
        // 暂时手动改成 7帖
        // this.prescription.Quantity = 7;

        obj.drugsList.forEach((i) => {
          let drugItem = this.drug.find((j) => j.Drug_Code == i.drugCode);
          if (drugItem) {
            this.resDrugList.push({
              ...i,
              drugTaboo: [],
              error: false,
              flevel: 0,
              active: false,
              Drug_Code: i.drugCode,
              Drug_Id: i.drugId,
              Drug_Name: i.drugName,
              Sales_Price: i.salesPrice,
              specifications: drugItem
                ? drugItem.specifications
                : i.specifications,
              drugDecoctPattern: drugItem
                ? drugItem.drugDecoctPattern
                : i.drugDecoctPattern,
              drugTakePattern: drugItem
                ? drugItem.drugTakePattern
                : i.drugTakePattern,
              StockQty: drugItem ? drugItem.StockQty : 0, //库存
              UnitName: drugItem ? drugItem.UnitName : i.unit,
              Amount: i.amount,
              Quantity: ["06", "01"].includes(drugItem.Drug_Type)
                ? i.quantity
                : 1, //["06", "01"] 按帖数来 其它默认1帖
              discountRate: i.discountRate,
              Drug_Type: drugItem ? drugItem.Drug_Type : "",
              // delBtn: this.bnf.indexOf(i.drugCode) != -1 ? true : false //删除按钮
              delBtn: false, //删除按钮
            });
          }
        });

        if (!this.hideAi) {
          this.prescription.drugList = this.resDrugList;
        } else {
          let title = "辨证开方"
          this.$store.commit("addMedicalRecordSymptom_add", {
            isShift: false,
            id: this.info.registerCode,
            data: {
              planInfo: {
                planName: "",
                planExplain: "",
              },
              title: title,
              remark: title,
              active: false,
              drugsList: this.resDrugList,
            },
          });
        }

        if (this.$refs.drugInput) {
          this.$refs.drugInput.setTaboos();
        }
      }
    },
    saveData() {
      if (!this.isStart && this.prescription.drugList.length) {
        this.$store.commit("savePrescription", {
          key: this.info.registerCode,
          prescription: this.prescription,
        });
      }
    },
    zaohui(fstatus) {
      this.$Modal.confirm({
        title: "确定召回此病历吗？",
        content:
          "<p>每个病历限定召回三次</p><p>召回后可修改症状，需重新提交</p>",
        onOk: () => {
          this.$store.dispatch("updateRecallMedicalRecordSymptom", {
            state: this.state, // 	状态(0开方未结束 1开方已结束)
            returnNum: 1, //0 没有限制次数召回 1 只能召回1次
            registerCode: this.info.registerCode, //挂号ID
            symptomNo: this.info.symptomNo, //症状
          });
          this.$store.commit("delPrescription", this.info.registerCode);
        },
      });
    },
    insertDrugFun(item) {
      if (item) {
        if (!item.planInfo) {
          item.planInfo.planName = "";
          item.planInfo.planExplain = "";
        }
        if (!this.prescription.planInfo) {
          this.prescription.planInfo = {
            planName: "",
            planExplain: "",
          };
        }
        Object.assign(this.prescription.planInfo, item.planInfo);
        if (item.planInfo.planName) {
          this.prescription.teaBagFlg = false;
        }
        this.$refs.drugInput?.setTeaBagFlg();
        this.loadCf(item.drugsList);

        // 如果手动修改过引用咨询的处方，则清除此标记
        sessionStorage.removeItem("consultFlg_" + this.info.registerCode);
      }
    },
    // 引用自动开方的处方数据
    loadCf(list) {
      if (!list) return;
      let notExistDrugList = [];
      this.prescription.drugList = [];
      list.forEach((x) => {
        var u_drug = this.drug.find((i) => i.Drug_Code == x.drugCode);
        if (u_drug) {
          var u_dr = this.common.clone(u_drug);
          u_dr.Amount = x.amount;
          u_dr.Quantity =
            u_drug.Drug_Type == "06" || u_drug.Drug_Type == "01"
              ? this.prescription.Quantity
              : 1;
          u_dr.active = false;
          u_dr.flevel = 0;
          u_dr.drugTaboo = [];
          u_dr.error = false;
          this.prescription.drugList.push(u_dr);
        } else {
          notExistDrugList.push(x);
        }
      });
      this.saveData();
      if (notExistDrugList.length) {
        this.$Modal.warning({
          title: "提示",
          content: `${notExistDrugList.map((i) => i.drugName).join("、")}不在药品库中, 导入失败！`,
        });
      }
    },

    // 查询上次是否主动咨询
    selectConsult() {
      this.api2("selectConsult", {
        patientCode: this.info.patientCode,
        diseaseCode: this.info.diagnosticId2,
      }).then((res) => {
        // 测试
        // res.result.activeConsult = 0;
        // res.result.consultDate = "2023-08-01";
        
        this.selectConsultData = res.result;
      });
    },

    selectConsultFun() {
      // 贴数如果小于5，提交处方时不发送强制医术咨询。如果医生上次主动咨询了，本次提交不弹出提醒医生是否继续发送咨询的弹框。
      if (this.prescription.Quantity < 5) {
        this.prescription.activeConsultFlg = 0;
        this.updateMedicalRecord();
        return;
      }

      // 上次是否咨询 1 是 0 否
      if (this.selectConsultData.activeConsult) {
        this.$Modal.confirm({
          title: "主动医术咨询确认",
          content: `患者【${this.info.patientName}】您在${this.selectConsultData.consultDate}主动咨询过，本次是否继续发送医术咨询？`,
          okText: "继续发送",
          cancelText: "不发送",
          onOk: () => {
            this.prescription.activeConsultFlg = 1;
            this.updateMedicalRecord();
          },
          onCancel: () => {
            this.prescription.activeConsultFlg = 0;
            this.updateMedicalRecord();
          },
        });
      } else {
        this.updateMedicalRecord();
      }
    },

    // 提交处方
    submitPrescription(e) {
      // 验证
      this.$refs.drugInput.validate().then((res) => {
        if (res) {
          if (this.prescription.teaBagFlg) {
            this.updateMedicalRecord();
          } else {
            this.selectConsultFun();
          }
        }
      });
    },

    closeTip() {
      this.showTip = false;
      // 刷新就诊列表
      this.$store.dispatch("getReloadOrderList");
    },

    // 前端医生保存处方
    async updateMedicalRecord() {
      var drugList = [];
      this.prescription.drugList.forEach((i) => {
        if (!i.Drug_Type) {
          let item = this.drug.find((j) => j.Drug_Code == i.Drug_Code);
          if (item) i.Drug_Type = item.Drug_Type;
        }
        drugList.push({
          amount: i.Amount, //	数量
          drugCode: i.Drug_Code, //	药品编码
          drugName: i.Drug_Name, //	药品名称
          drugType: i.Drug_Type || "01", //	药品类型
          quantity: i.Quantity, //	贴数
          specifications: i.specifications, //	药品规格
          unit: i.UnitName, //	单位名称
          drugTakePattern: i.drugTakePattern, //
          StockQty: i.StockQty, //库存
          drugDecoctPattern: i.drugDecoctPattern, //
        });
      });

      let consultFlg = 0;
      // 此为编辑处方时返回的是否引用咨询处方的标记
      let d = sessionStorage.getItem("consultFlg_" + this.info.registerCode);
      if (d) {
        consultFlg = Number(d);
      } else {
        consultFlg =
          this.prescription.planInfo && this.prescription.planInfo.planName
            ? 1
            : 0; // 是否是咨询处方 1 是 0 否
      }

      let fzRemindDate = this.prescription.fzRemindDate ? dayjs(this.prescription.fzRemindDate) : null;

      var newData = {
        ...this.prescription,
        activeConsultFlg: this.prescription.activeConsultFlg,
        consultFlg,
        teaBagFlg: consultFlg ? 0 : this.prescription.teaBagFlg ? 1 : 0, // 是否是茶包处方 1 是 0 否
        drugList,
        returnVisitDate: fzRemindDate ? fzRemindDate.add(1, "day").format("YYYY-MM-DD") : dayjs(this.prescription.returnVisitDate).format("YYYY-MM-DD"),
        fzRemindDate: fzRemindDate ? fzRemindDate.format("YYYY-MM-DD") : null, 
        quantity: this.prescription.Quantity,
        prescriptionNo: this.info.prescriptionNo, //前端医生用
        symptomNo: this.info.symptomNo, //专家医生用
        patientType: this.info.patientType, // 患者类型
      };

      this.pageType && Object.assign(newData, this.keyInfo);

      if (this.info.isInternetHospital) {
        sessionStorage.setItem("isInternetHospital", 1);
      }
      this.$store.commit("openSpin");
      let fun = this.pageType ? "updateMedicalRecord" : "addMedicalRecord";
      this.api2(fun, newData)
        .then(async (res) => {
          this.saveMedicalRecordLog(newData.drugList);
          this.$store.commit("removeTabooDiscriminate", this.info.registerCode);

          this.$store.commit("confirmN_tip", false);
          if (this.info.isInternetHospital) {
            this.showTip = true;
          } else {
            this.$Message.success(res.result);
            await this.$store.dispatch("getReloadOrderList");
          }

          if (this.pageType) {
            //前端医生
            this.$store.commit("delPrescription", this.info.registerCode);
            if (this.userSystemConfig.printPrescription) {
              this.$store.commit("medicalRecordPringWin", {
                info: this.common.clone(this.info),
                quantity: this.prescription.Quantity,
                drugList: this.common.clone(this.drugListFormat),
                show: true,
              });
            } else {
              this.$store.commit("clickVisit");
            }

            this.$store.commit("sendLog", {
              apiName: "updateMedicalRecord",
              remarks: "合作医生保存处方 ",
              inParams: newData,
              outParams: res,
            });
          } else {
            //专家医生
            localStorage.removeItem("addDoctorRushBill");
            this.$router.push("/index");
          }

          // 清缓存数据
          sessionStorage.removeItem(
            "etiologyReasonList_" + this.info.registerCode
          );
          sessionStorage.removeItem(
            "listPatientMainSymptom_submit_" + this.info.registerCode
          );
          sessionStorage.removeItem(
            "listSymptomEtiologyDialectical_" + this.info.registerCode
          );
          localStorage.removeItem("selectList_" + this.info.registerCode);
          sessionStorage.removeItem(
            "autoPrescriptionError_" + this.info.registerCode
          );
          this.sendDiseaseToPad();
        })
        .finally(() => {
          this.$store.commit("closeSpin");
          setTimeout(() => {
            sessionStorage.removeItem("isInternetHospital");
          }, 1000);
        });
    },

    // 发送消息到PAD
    sendDiseaseToPad() {
      // 发送症状到pad
      let objSend = {
        messageType: 3, // 1 症状确认消息 2 五行辩证图 3 提交处方关闭五行辩证图
      };
      this.api2("sendingSymptoms", objSend).then((res) => { });
    },

    // 提交处方保存日志
    saveMedicalRecordLog(newData) {
      let key = `modifyDrug-${this.info.registerCode}`;
      let changeRecord = localStorage.getItem(key);
      this.api2("saveMedicalRecordLog", {
        patientCode: this.info.patientCode,
        oldData: this.resPrescribe,
        newData: JSON.stringify(newData),
        changeRecord,
      }).then((res) => {
        localStorage.removeItem(key);
      });
    },

    init() {
      // 是否自动开方报错
      this.autoPrescriptionError = sessionStorage.getItem(
        "autoPrescriptionError_" + this.info.registerCode
      );

      let selectList = localStorage.getItem(
        "selectList_" + this.info.registerCode
      );

      this.etiologicalAnalysisVShow = this.hideAi ? false : true;

      // 如果有病因分析过了默认就不打开分析页
      this.etiologicalAnalysisShow =
        this.isAnalysisList.find((i) => i == this.info.registerCode) ||
          !selectList
          ? false
          : true;

      this.$store.commit("setIsRecall", 0);
      this.$store.commit("setSpinShow", true);
      // 初始化处方信息
      this.prescription = {
        Quantity: 1,
        drugList: [],
        returnVisitDate: "", //应复诊时间
        fzRemindDate: "", //复诊提醒时间
        planInfo: {
          planName: "",
          planExplain: "",
        }, // 方案信息
        teaBagFlg: false, //是否是茶包处方 1 是 0 否
        activeConsultFlg: 0, //是否继续主动咨询 1 是 0 否
      };
      this.sendMessageSecond = 1;
      this.$store.commit("initN_tip");
      if (this.pageType) {
        this.getPrescribeByBillNoList();
      } else {
        this.loadCf(this.prescribeRegisterList.drugList);
      }
      // 查询上次是否主动咨询
      this.selectConsult();
    },
    removePlanInfo() {
      if (this.prescription.planInfo) {
        this.prescription.planInfo.planName = "";
        this.prescription.planInfo.planExplain = "";
      }
    },
  },
  created() {
    this.init();
    this.$bus.on("HIDEAI", (data) => {
      switch (data) {
        case "bingyinfenxiWorkFlow":
          this.etiologicalAnalysisWorkFlowShow = true;
          break;
        case "bingyinfenxi":
          this.etiologicalAnalysisShow = true;
          this.etiologicalAnalysisVShow = true;
          break;
        case "tuijianchufang":
          if (!this.prescription.drugList.length) {
            if (this.recordSymptom.length) {
              let item = this.recordSymptom[0];
              this.insertDrugFun(item);
              this.$bus.emit("setPrescriptionSelectActive", item.drugsList.map((i) => i.drugCode));
            } else {
              this.prescription.drugList = [...this.resDrugList];
            }
          }
          break;
      }
    });
  },
  mounted() {
    this.$bus.on("quotingPrescriptions", this.removePlanInfo);
  },
  beforeDestroy() {
    this.$bus.off("quotingPrescriptions", this.removePlanInfo);
  },
};
</script>

<style lang="scss">
.prescription_input {
  height: 100%;

  .ucard {
    margin-bottom: 0;
    height: 100%;
    display: flex;
    flex-direction: column;

    .ucard_hander {
      background: rgba(133, 58, 47, 0.15);
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 5px 5px 0 0;
      padding: 8px 15px;

      .ucard_title {
        color: #853a2f;
        font-weight: bold;
      }

      .ucard_title_right {
        display: flex;

        &>* {
          margin-left: 10px;
        }
      }
    }

    .ucard_body {
      border: 1px solid #ddd;
      padding: 15px;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      position: relative;

      .u_table2 {
        // flex: 1;
        // flex-shrink: 0;
        // min-height: 100px;
        flex-grow: 1;
        flex-shrink: 0;
        height: 350px;
      }
    }
  }

  .u_medical_advice {
    .tip {
      padding-top: 20px;
      opacity: 0.8;
    }

    .auto-prescr-error {
      .title {
        width: 500px;
        font-weight: bold;
        font-size: 16px;
      }

      .content {
        width: 500px;
        padding-bottom: 20px;
      }
    }
  }
}
</style>
